/* ToolbarDropdownItem.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./ToolbarDropdownItem.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef, isValidElement, cloneElement } from 'react';
import { cx } from '@atlaskit/css';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { Pressable } from '@atlaskit/primitives/compiled';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { useToolbarDropdownMenuNew } from './ToolbarDropdownMenuContext';
var styles = {
  toolbarDropdownItem: "_11c82smr _18zrutpp _1rjc1b66 _1e0c1txw _kqswh2mm _bfhksm61 _1bsb1osq _1tkezwfg _1ul9eoa3 _syaz1gjq _1bas12b0 _1ah31i6y",
  enabled: "_irr3166n _1di61dty",
  disabled: "_syaz1lh4 _80om13gf",
  selected: "_bfhkfg4m _syazaqb7 _irr3i1yw _1di619ru"
};
var CustomDropdownMenuItemButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    testId = _ref['data-testid'],
    ariaHasPopup = _ref['aria-haspopup'],
    ariaDisabled = _ref['aria-disabled'],
    ariaPressed = _ref['aria-pressed'],
    ariaKeyshortcuts = _ref['aria-keyshortcuts'],
    onClick = _ref.onClick,
    tabIndex = _ref.tabIndex;
  return /*#__PURE__*/React.createElement(Pressable, {
    testId: testId,
    xcss: cx(styles.toolbarDropdownItem, ariaDisabled ? styles.disabled : ariaPressed ? styles.selected : styles.enabled),
    onClick: onClick,
    tabIndex: tabIndex,
    "aria-haspopup": ariaHasPopup,
    "aria-expanded": ariaHasPopup ? ariaPressed ? true : false : undefined,
    "aria-pressed": ariaPressed,
    "aria-disabled": ariaDisabled,
    "aria-keyshortcuts": ariaKeyshortcuts,
    ref: ref
  }, children);
});
export var ToolbarDropdownItem = function ToolbarDropdownItem(_ref2) {
  var onClick = _ref2.onClick,
    elemBefore = _ref2.elemBefore,
    elemAfter = _ref2.elemAfter,
    isSelected = _ref2.isSelected,
    children = _ref2.children,
    isDisabled = _ref2.isDisabled,
    hasNestedDropdownMenu = _ref2.hasNestedDropdownMenu,
    triggerRef = _ref2.triggerRef,
    _ref2$shouldTitleWrap = _ref2.shouldTitleWrap,
    shouldTitleWrap = _ref2$shouldTitleWrap === void 0 ? true : _ref2$shouldTitleWrap,
    testId = _ref2.testId,
    ariaKeyshortcuts = _ref2.ariaKeyshortcuts,
    href = _ref2.href,
    target = _ref2.target,
    rel = _ref2.rel;
  var parentContext = useToolbarDropdownMenuNew();
  var injectedElemAfter = function () {
    if (! /*#__PURE__*/isValidElement(elemAfter)) {
      return elemAfter;
    }
    var elementProps = elemAfter.props;
    if ('isDisabled' in elementProps) {
      return elemAfter;
    }
    return /*#__PURE__*/cloneElement(elemAfter, _objectSpread(_objectSpread({}, elementProps), {}, {
      isDisabled: isDisabled
    }));
  }();
  return /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: expValEquals('platform_editor_toolbar_aifc_patch_1', 'isEnabled', true) ? function (e) {
      if (!hasNestedDropdownMenu) {
        parentContext === null || parentContext === void 0 || parentContext.closeMenu();
      }
      onClick === null || onClick === void 0 || onClick(e);
    } : onClick,
    elemBefore: elemBefore,
    elemAfter: expValEquals('platform_editor_toolbar_aifc_patch_5', 'isEnabled', true) ? injectedElemAfter : elemAfter,
    isSelected: isSelected,
    isDisabled: isDisabled,
    "aria-haspopup": hasNestedDropdownMenu,
    "aria-pressed": isSelected,
    "aria-keyshortcuts": ariaKeyshortcuts,
    ref: triggerRef,
    href: href,
    target: target,
    rel: rel
    // @ts-ignore -- This `CustomDropdownMenuItemButton` has type conflicts with the `DropdownItem` component in a way that cannot be reconciled (ignored as it fails types in Jira and should in Platform)
    ,
    component: href && expValEquals('platform_editor_toolbar_migrate_loom', 'isEnabled', true) ? undefined : CustomDropdownMenuItemButton,
    testId: testId,
    "data-toolbar-component": "menu-item",
    shouldTitleWrap: shouldTitleWrap
  }, children);
};